<template>
  <div id="app">
    <router-view @showShortCut="handleShortCut"></router-view>
    <short-cut :keyBoardVisible="keyBoardVisible" @update:keyBoardVisible="keyBoardVisible = $event"></short-cut>
  </div>
</template>
<script>
// import { Message } from 'element-ui' // 已禁用快捷键功能,暂时注释
import { getInfo } from '@/api/user'
import { createTable, createFavorite } from '@/utils/mysqTools'
export default {
  name: 'App',
  data() {
    return {
      // 控制是否显示退出提醒
      showExitReminder: true,
      // 提醒信息
      exitMessage: '你确定要离开此页面吗？你可能有未保存的更改!',
      theme: null,
      keyBoardVisible: false
    }
  },
  async created() {
    // 先获取用户信息
    try {
      const res = await getInfo()
      const tableName = res.data.user.basic.c_name + res.data.user.basic.id
      await createTable({ table: tableName })
      await createFavorite({ table: tableName })
    } catch (error) {
      console.log(error)
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    // 主动触发一次 popstate 检测，确保进入页面时能立即生效
    window.addEventListener('popstate', this.handlePopState)
    // 监听图库中心
    window.addEventListener('keydown', this.handleGallery)
    // 监听模块环境 - 已禁用快捷键
    // window.addEventListener('keydown', this.handleModule)
    // 全局查看快捷键
    window.addEventListener('keydown', this.handleKeyShow)
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    window.removeEventListener('popstate', this.handlePopState)
    window.removeEventListener('keydown', this.handleGallery)
  },
  beforeDestroy() {
    // 移除键盘事件监听器
    window.removeEventListener('keydown', this.handleGallery)
    // window.removeEventListener('keydown', this.handleModule) // 已禁用快捷键
  },
  methods: {
    handleShortCut(x) {
      this.keyBoardVisible = true
    },
    // 全局查看快捷键
    handleKeyShow(event) {
      if (event.shiftKey && event.key === 'S') {
        this.keyBoardVisible = !this.keyBoardVisible
      }
    },
    // 模块环境检测 - 已禁用快捷键
    handleModule(event) {
      // 快捷键功能已关闭,直接忽略所有按键事件
      /* 已禁用的快捷键配置
      const shortCut = {
        1: '/function/matting',
        2: '/partialredraw',
        3: '/broadpicture',
        4: '/wanmove',
        5: '/removecontainer',
        6: '/imageeditindex/kontext_v2',
        7: '/imageeditindex/editimage',
        0: '/fingernailchange'
      }
      const keyCodeArray = ['1', '2', '3', '4', '5', '6', '7', '0']
      try {
        if (event.ctrlKey && keyCodeArray.includes(event.key)) {
          event.preventDefault()
          if (event.key in keyCodeArray) {
            if (this.$route.path !== shortCut[event.key]) {
              this.$router.push({ path: shortCut[event.key] }).catch(err => {
                if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
                  Message.error('操作过快,系统无法及时响应操作!')
                }
              })
            }
          }
        }
      } catch (error) {
        Message.error('系统错误,请刷新后重新操作!')
      }
      */
    },
    // 监听图库
    handleGallery(event) {
      if (event.shiftKey && event.key === 'P') {
        if (this.$route.path === '/index/imagecenter') {
          return
        }
        try {
          this.$router.push({ path: '/index/imagecenter' })
        } catch {
          console.log('图库')
        }
      }
    },
    handleBeforeUnload(event) {
      if (!this.showExitReminder) return
      event.preventDefault()
      event.returnValue = this.exitMessage
    },
    handlePopState() {
      // 检测用户点击了返回按钮或调用了 history.back()
      if (this.showExitReminder && !window.confirm(this.exitMessage)) {
        history.pushState(null, '', location.href)
      }
    },
    // 可选：提供一个方法来临时禁用提醒
    disableExitReminder() {
      this.showExitReminder = false
    },
    // 可选：提供一个方法来重新启用提醒
    enableExitReminder() {
      this.showExitReminder = true
    }
  }
}
</script>
<style lang="less">
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

html,
body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  overflow: hidden;
  // background-color: #ffffff;
  transition: all 0.8s;
}

#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
